// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ux7v","left":"styles_left__2ntmS","desktopActions":"styles_desktopActions__1jqWR","title":"styles_title__28z0S"};